import pilot from "../../api/pilot"
import { getItem, setItem } from "../../plugins/localStorage"

const state = {
  accessToken: null,
  user: null,
  event_guid: null,
}

const getters = {
  accessToken() {
    return state.accessToken
  },
  guid() {
    if (state.user != null) {
      return state.user.guid_text
    }
    return null
  },
}

const actions = {
  async login({ commit, rootState }) {
    await pilot.login(({ accessToken, user }) => {
      setItem({ name: "accessToken", value: accessToken })
      commit("setAccessToken", accessToken)
      commit("setUser", user)
      commit("setEventGuid", "e0153a87-282c-4804-9298-f173378d9046")
      setItem({ name: "event_guid", value: "e0153a87-282c-4804-9298-f173378d9046" })
    })
    await pilot.userGuid(state.event_guid, (user_guid, user_token) => {
      commit("setUserGuid", user_guid)
      commit("setUserToken", user_token)
      setItem({ name: "user", value: state.user })
    })
    return
  },

  setPilot({ commit }, { user, token }) {
    setItem({ name: "accessToken", value: token })
    commit("setAccessToken", token)
    commit("setUser", user)
    setItem({ name: "user", value: state.user })
  },

  async setEvent({ commit, rootState }, { event_guid }) {
    console.log("setEvent", event_guid)
    commit("setEventGuid", event_guid)
    setItem({ name: "event_guid", value: event_guid })
    await pilot.userGuid(state.event_guid, (user_guid, user_token) => {
      commit("setUserGuid", user_guid)
      commit("setUserToken", user_token)
      setItem({ name: "user", value: state.user })
    })
  },

  async setOptionsFromSaved({ commit, rootState }) {
    let pilot = {
      user: getItem("user"),
      accessToken: getItem("accessToken"),
      event_guid: getItem("event_guid"),
    }
    if (pilot.user !== null) {
      commit("setPilot", pilot)
    }
  },
}

const mutations = {
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken
  },

  setUser(state, user) {
    state.user = user
  },

  setUserGuid(state, user_guid) {
    state.user.guid_text = user_guid
  },

  setUserToken(state, user_token) {
    state.user.token = user_token
  },

  setEventGuid(state, event_guid) {
    state.event_guid = event_guid
  },

  setPilot(state, pilot) {
    state.user = pilot.user
    state.accessToken = pilot.accessToken
    state.event_guid = pilot.event_guid
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
